import React, { Component } from 'react';
import { connect } from 'react-redux';
import { togglePrompt } from '../../store/actions/commonActions';

import ProjectConfirmations from './ProjectConfirmations';
import ProgressingButton from '../../common/ProgressingButton';

class ProjectApprovalButtons extends Component {
  constructor(props){
    super(props);

    this.confirmAction = '';
    this.projectId = '';
    this.projectName = '';
  }

  render() {
    return (
      <>
        <ProjectConfirmations confirmAction={this.confirmAction} projectId={this.projectId} projectName={this.projectName} />
        <ProgressingButton 
          className="mr-1 rejectButton" 
          size={this.props.inPage ? "md" : "sm"} 
          variant="danger" 
          buttonValue="Reject" 
          onClick={() => {
            this.confirmAction = 'REJECT_PROJECT';
            this.projectId = this.props.project.id;
            this.projectName = this.props.project.project_name;
            this.props.togglePrompt(true);
          }} />
        <ProgressingButton 
          className="mr-1 approveButton" 
          size={this.props.inPage ? "md" : "sm"} 
          variant="success" 
          buttonValue="Approve" 
          onClick={() => {
            this.confirmAction = 'APPROVE_PROJECT';
            this.projectId = this.props.project.id;
            this.projectName = this.props.project.project_name;
            this.props.togglePrompt(true);
          }} />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    togglePrompt: (...args) => dispatch(togglePrompt(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectApprovalButtons)
